import { OrganizationGroupActionTypes, UPDATE_ORG_GROUP_API_SUCCESS } from './organization-group.actions';
import {
  DELETE_ORG_GROUP_API_SUCCESS,
  ORG_GROUP_ORGANIZATIONS_GOTO_PAGE,
  OrganizationGroupManagementActionTypes,
  Page,
  RESET_ORG_GROUP_ORGANIZATIONS,
  SEARCH_ORG_GROUP_ORGANIZATIONS_API_REQUESTED,
  SEARCH_ORG_GROUP_ORGANIZATIONS_API_SUCCESS,
  SEARCH_UNUSED_ORG_GROUPS_API_SUCCESS,
  UNUSED_ORG_GROUPS_GOTO_PAGE,
  UPDATE_ORG_GROUP_ORGANIZATION_FILTERS,
} from './organization-group-management.actions';
import { ORGANIZATION_GROUP_MANAGEMENT_PAGE_SIZE } from './organization-group-management.saga';
import { OrganizationGroupManagementState } from './organization-group-management.types';

const initialManagementState = {
  count: 0,
  filters: {
    incomplete: false,
    query: '',
  },
  hasSearched: false,
  page: 1,
  results: [],
};

const getPageNumber = (target: Page, currentPage: number, count: number) => {
  const lastPage = Math.ceil(count / ORGANIZATION_GROUP_MANAGEMENT_PAGE_SIZE);
  let page = target;

  if (page === 'prev') page = currentPage - 1;
  if (page === 'next') page = currentPage + 1;
  if (page >= lastPage) page = lastPage;
  if (page <= 0) page = 1;

  return page;
};

const initialState: OrganizationGroupManagementState = {
  organizations: initialManagementState,
  unused: {
    count: 0,
    page: 1,
    results: [],
  },
};

export default (
  state: OrganizationGroupManagementState | undefined,
  action: OrganizationGroupManagementActionTypes | OrganizationGroupActionTypes,
): OrganizationGroupManagementState => {
  const currentState = state || initialState;

  switch (action.type) {
    case UPDATE_ORG_GROUP_API_SUCCESS:
      return {
        ...currentState,
        organizations: {
          ...currentState.organizations,
          results: currentState.organizations.results.map((organization) =>
            organization.id === action.payload.id
              ? {
                  ...organization,
                  organizationGroup: action.payload.organizationGroup,
                  parentOrganizationGroup: action.payload.parentOrganizationGroup,
                }
              : organization,
          ),
        },
      };
    case SEARCH_ORG_GROUP_ORGANIZATIONS_API_REQUESTED:
      return {
        ...currentState,
        organizations: {
          ...currentState.organizations,
          hasSearched: true,
        },
      };
    case ORG_GROUP_ORGANIZATIONS_GOTO_PAGE:
      return {
        ...currentState,
        organizations: {
          ...currentState.organizations,
          page: getPageNumber(action.payload, currentState.organizations.page, currentState.organizations.count),
        },
      };
    case UPDATE_ORG_GROUP_ORGANIZATION_FILTERS:
      return {
        ...currentState,
        organizations: {
          ...currentState.organizations,
          filters: {
            ...currentState.organizations.filters,
            ...action.payload,
          },
          page: 1,
        },
      };
    case SEARCH_ORG_GROUP_ORGANIZATIONS_API_SUCCESS:
      return {
        ...currentState,
        organizations: {
          ...currentState.organizations,
          count: action.payload.count,
          results: action.payload.results,
        },
      };
    case RESET_ORG_GROUP_ORGANIZATIONS:
      return {
        ...currentState,
        organizations: initialManagementState,
        unused: initialState.unused,
      };
    case UNUSED_ORG_GROUPS_GOTO_PAGE:
      return {
        ...currentState,
        unused: {
          ...currentState.unused,
          page: getPageNumber(action.payload, currentState.unused.page, currentState.unused.count),
        },
      };
    case SEARCH_UNUSED_ORG_GROUPS_API_SUCCESS:
      return {
        ...currentState,
        unused: {
          ...currentState.unused,
          count: action.payload.count,
          results: action.payload.results,
        },
      };
    case DELETE_ORG_GROUP_API_SUCCESS:
      return {
        ...currentState,
        unused: {
          ...currentState.unused,
          count: Math.max(0, currentState.unused.count - 1),
          results: currentState.unused.results.filter((organizationGroup) => organizationGroup.id !== action.payload),
        },
      };
    default:
      return currentState;
  }
};
